import { render, staticRenderFns } from "./LicenseInformation.vue?vue&type=template&id=1bb18cbe&scoped=true"
import script from "./LicenseInformation.vue?vue&type=script&lang=js"
export * from "./LicenseInformation.vue?vue&type=script&lang=js"
import style0 from "./LicenseInformation.vue?vue&type=style&index=0&id=1bb18cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb18cbe",
  null
  
)

export default component.exports